import useGetApi from 'src/api/useGetApi';

export interface OrganizationMemberDTO {
  userId: string;
  name: string;
  email: string;
  isAdmin: boolean;
  deactivatedAt: string | null;
  groups: { groupId: string; name: string }[];
}

type ApiResponse = {
  members: OrganizationMemberDTO[];
};

const useOrganizationMembers = (enabled?: boolean) => {
  return useGetApi<ApiResponse>({
    endpoint: 'organization/members',
    options: {
      enabled,
    },
  });
};

export default useOrganizationMembers;
